import { isClient } from './lib/utils';
export default class Tracker {
    track(event, payload) {
        if (isClient()) {
            let additionalData = {};
            if (payload) {
                additionalData = typeof payload === 'object' ? payload : { data: payload };
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event, ...additionalData });
        }
    }
}
//# sourceMappingURL=tracker.js.map